import type { ReactNode } from 'react';

/**
 * Search result item with category and metadata
 */
export interface SearchResultItem {
  /** Unique identifier */
  id: string;
  /** Display title */
  title: string;
  /** Optional subtitle/description */
  subtitle?: string | undefined;
  /** Category for grouping */
  category: 'recent' | 'pages' | 'actions';
  /** Icon to display */
  icon?: ReactNode;
  /** Keyboard shortcut hint */
  shortcut?: string[];
  /** Action to perform on select */
  onSelect?: () => void;
  /** URL to navigate to */
  href?: string;
}

/**
 * Category metadata for display
 */
export interface SearchCategory {
  id: 'recent' | 'pages' | 'actions';
  label: string;
  icon?: ReactNode;
}

/**
 * SearchCommand component props
 */
export interface SearchCommandProps {
  /** Whether the command palette is open */
  isOpen: boolean;
  /** Callback when palette should close */
  onClose: () => void;
  /** Search results to display */
  results?: SearchResultItem[];
  /** Placeholder text for search input */
  placeholder?: string;
  /** Callback when search query changes */
  onSearch?: (query: string) => void;
  /** Callback when a result is selected */
  onSelect?: (item: SearchResultItem) => void;
  /** Loading state */
  loading?: boolean;
  /** Custom class name */
  className?: string;
}

/**
 * SearchTrigger component props
 */
export interface SearchTriggerProps {
  /** Click handler to open search */
  onClick: () => void;
  /** Compact mode (icon only) */
  compact?: boolean;
  /** Custom class name */
  className?: string;
}

/**
 * Default categories with labels
 */
export const SEARCH_CATEGORIES: SearchCategory[] = [
  { id: 'recent', label: 'Recent' },
  { id: 'pages', label: 'Pages' },
  { id: 'actions', label: 'Actions' },
];
